import createIcon from '../../createIcon';

/**
 * @component @name Forum
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEgNkgxOVYxNUg2VjE3QzYgMTcuNTUgNi40NSAxOCA3IDE4SDE4TDIyIDIyVjdDMjIgNi40NSAyMS41NSA2IDIxIDZaTTE3IDEyVjNDMTcgMi40NSAxNi41NSAyIDE2IDJIM0MyLjQ1IDIgMiAyLjQ1IDIgM1YxN0w2IDEzSDE2QzE2LjU1IDEzIDE3IDEyLjU1IDE3IDEyWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Forum = createIcon('Forum', [
  [
    'path',
    {
      d: 'M21 6H19V15H6V17C6 17.55 6.45 18 7 18H18L22 22V7C22 6.45 21.55 6 21 6ZM17 12V3C17 2.45 16.55 2 16 2H3C2.45 2 2 2.45 2 3V17L6 13H16C16.55 13 17 12.55 17 12Z',
      key: '15i9qx',
    },
  ],
]);

export default Forum;
